import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bilanz',
  templateUrl: './bilanz.component.html',
  styleUrls: ['./bilanz.component.scss']
})
export class BilanzComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
